import { useEffect, useRef } from 'react'

/** Ref pro animovanou ikonu, která se jednou přehraje hned po zobrazení (potvrzení akce). */
export const usePlayOnMount = <T extends { startAnimation: () => void }>() => {
  const ref = useRef<T>(null)
  useEffect(() => {
    ref.current?.startAnimation()
  }, [])
  return ref
}
